import { Link } from 'react-router-dom';
import { ScanFace, ShieldCheck, LogIn, Sparkles, LayoutGrid, Home } from 'lucide-react';
import { PoweredBy } from '../PoweredBy';

export const PublicShell = ({ tenant, children, right }) => {
  const hideBranding = !!tenant?.branding?.hide_branding;
  return (
    <div className="min-h-screen bg-ink flex flex-col" data-testid="public-shell">
      <header className="glass-header">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Link
            to={tenant ? `/t/${tenant.slug}` : '/'}
            className="flex items-center gap-3 text-white font-display font-bold uppercase tracking-tight min-w-0"
            data-testid="public-tenant-name"
          >
            <span className="w-9 h-9 shrink-0 bg-cyan text-ink border-2 border-cyan flex items-center justify-center font-display font-bold text-base">
              {tenant?.name ? tenant.name.charAt(0).toUpperCase() : <ScanFace className="w-4 h-4" />}
            </span>
            <span className="truncate">{tenant?.name || 'Event Photos'}</span>
          </Link>
          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            {(tenant?.is_demo || !tenant) && (
              <Link to="/" className="btn-ghost !py-2" data-testid="public-home-btn" title="Back to Spotfie">
                <Home className="w-4 h-4" /> <span className="hidden sm:inline">Back to Spotfie</span>
              </Link>
            )}
            <span className="hidden lg:inline-flex badge-lime !py-0.5" data-testid="public-privacy-badge">
              <ShieldCheck className="w-3 h-3" /> Selfies never stored
            </span>
            {right}
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-10 sm:py-14">{children}</main>
      {tenant?.is_demo && (
        <div className="max-w-4xl w-full mx-auto px-4 pb-6" data-testid="public-demo-strip">
          <div className="card-brutal-lime p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <p className="text-sm text-slate-300"><span className="font-display font-bold uppercase tracking-wider text-white">Demo event.</span> This is how your guests would see it.</p>
            <div className="flex flex-wrap gap-2">
              <Link to="/demo" className="btn-ghost !py-2 !text-[11px]" data-testid="public-demo-hub-link"><LayoutGrid className="w-3.5 h-3.5" /> Demo hub</Link>
              <Link to="/signup" className="btn-lime !py-2 !px-3 !text-[11px]" data-testid="public-demo-signup-link"><Sparkles className="w-3.5 h-3.5" /> Create my free event</Link>
            </div>
          </div>
        </div>
      )}
      <PoweredBy hidden={hideBranding} />
      <div className="flex justify-center pb-6">
        <Link to="/login" data-testid="organiser-login-link" className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-cyan transition-colors">
          <LogIn className="w-3 h-3" /> Organiser login
        </Link>
      </div>
    </div>
  );
};
